import { ShieldCheck } from "lucide-react";

const SelloBadge = ({ className = "", size = "sm" }) => {
  const dims = size === "lg" ? "text-sm px-3 py-1.5" : "text-[10px] px-2 py-1";
  return (
    <span
      data-testid="sello-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-emerald-500/15 border border-emerald-500/40 font-mono-tech uppercase tracking-wider text-emerald-400 font-semibold ${dims} ${className}`}
    >
      <ShieldCheck className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} />
      Sello ZeroToxic
    </span>
  );
};

export default SelloBadge;
